export default __webpack_public_path__ + "static/media/react-router.3b9cbb79.svg";